import { useState } from 'react';
import { Lock } from 'lucide-react';
import DebugPanel from '@/components/DebugPanel';
import PageHeader from '@/components/PageHeader';

export default function DebugPage() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState('');
  const adminPassword = 'innotec2024'; // En un caso real, esto debería estar en un entorno seguro

  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    if (password === adminPassword) {
      setIsAuthenticated(true);
    } else {
      alert('Contraseña incorrecta');
    }
  };

  if (!isAuthenticated) {
    return (
      <div className="container mx-auto px-4 py-12 min-h-screen flex flex-col items-center justify-center">
        <div className="bg-zinc-900/70 border border-white/10 rounded-lg p-8 max-w-md w-full">
          <h2 className="text-xl font-bold text-white mb-6 text-center flex items-center justify-center gap-2">
            <Lock className="w-5 h-5 text-[#FCAA0D]" />
            Panel de administración
          </h2>

          <form onSubmit={handleLogin} className="space-y-4">
            <div className="space-y-2">
              <label htmlFor="password" className="text-white/90 text-sm">
                Contraseña de administrador
              </label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full bg-zinc-800/50 border border-zinc-700/50 rounded-lg px-3 py-2 text-white"
                placeholder="Introduce la contraseña"
              />
            </div>

            <button
              type="submit"
              className="w-full bg-[#FCAA0D] text-zinc-900 font-bold px-6 py-3 rounded-xl hover:bg-[#FCAA0D]/90 transition-colors"
            >
              Acceder
            </button>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-12">
      <PageHeader
        title="Panel de administración"
        subtitle="Herramientas de diagnóstico"
        description="Utiliza estas herramientas para diagnosticar problemas con el servicio de autenticación y correo electrónico."
        centered={false}
      />

      <DebugPanel />
    </div>
  );
}
